module.exports = __webpack_public_path__ + "assets/img/2.f6e3bbc6.jpg";